export default __webpack_public_path__ + "static/media/chess.41b720b9.png";